import { helperFunctions } from "../helper";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { URLConfig } from "../network";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";

export const createProtocol = (requestPayload: any): Observable<any> => {
  let url = URLConfig.protocolTrialMasterDataURL();

  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const getProtocol = (
  queryParams?: Array<{
    key: OdQueryParam|AgTechQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.protocolTrialMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const getSpecificProtocol = (id: number): Observable<any> => {
  let url = URLConfig.protocolTrialMasterDataURLById(id);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};
export const getProtocolsNextPage = (nextPageURI: string): Observable<any> => {
  let url = URLConfig.getProtocolNextPageURLTrialMasterDataURL(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (protocolResponse: any) => {
        if (protocolResponse) {
          subscriber.next(protocolResponse);
        }

        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Protocols master data", error);
      }
    );
  });
};


export const getAllProtocols = (
  queryParams?: Array<{
    key: AgTechQueryParam|OdQueryParam;
    value: string[];
  }>
): Observable<any[]> => {
  let allProtocols: any[] = [];

  return new Observable((subscriber) => {
    const handleError = (error: any) => {
      subscriber.error(error);
      console.error("Error while fetching Protocols master data", error);
    };

    const handleResponse = (response: any) => {
      allProtocols = [...allProtocols, ...(response.protocols || [])];

      if (response.nextPageUri) {
        getProtocolsNextPage(response.nextPageUri).subscribe({
          next: handleResponse,
          error: handleError,
        });
      } else {
        subscriber.next(allProtocols);
        subscriber.complete();
      }
    };

    getProtocol(queryParams).subscribe({
      next: handleResponse,
      error: handleError,
    });
  });
};


export const updateProtocol = (
  requestPayload: any,
  id: number
): Observable<any> => {
  let url = URLConfig.protocolTrialMasterDataURLById(id);

  return new Observable((subscriber) => {
    NetworkService.put(url, requestPayload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const getContentLengthForProtocol = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.protocolTrialMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const deleteProtocol = (
  protocolId: number
): Observable<any> => {
  let url = URLConfig.protocolTrialMasterDataURLById(protocolId);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (res: any) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while deleting location master data", error);
      }
    );
  });
};
